import React from "react";


const SrFixationForm6 = ({ formData, setFormData, onBack, onSubmit, visibleFields = [] }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Reusable render helper
  const renderDateField = (label, name) => {
    if (!visibleFields.includes(name)) return null;
    return (
      <label>
        {label}
        <div style={{ display: "flex", flexDirection: "column" }}>
          <input
            type="date"
            name={name}
            placeholder={label}
            value={formData[name] || ""}
            onChange={handleInputChange}
          />
        </div>
      </label>
    );
  };

  return (
    <div className="google_forms">
      <div className="forms">
        <form>
          <h3>इतर माहिती</h3>

          {renderDateField("वरिष्ठ मंजूर दिनांक:", "seniorityApprovalDate")}
          {renderDateField("आश्वासित प्रगती योजना लाभ -१ मंजूर दिनांक:", "apyl1ApprovalDate")}
          {renderDateField("पदोन्नती -१ दिनांक:", "promotion1Date")}
          {renderDateField("पदोन्नती -२ दिनांक:", "promotion2Date")}
          {renderDateField("कोणत्या तारखेपर्यंत वेतननिश्चिती करावयाची आहे?", "fixationTillDate")}

          <button type="button" onClick={onBack}>
            Back
          </button>
          <button type="button" className="submit-button" onClick={onSubmit}>
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default SrFixationForm6;
